
export const tabs = [
    {
        name: 'General',
        title: 'General',
        className: 'general',
    },
    {
        name: 'style',
        title: 'Style',
        className: 'style',
    } 
];